export const ADMIN_ROUTE = '/administrator'
export const MP_ROUTE = '/'

